// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yidl1","newExpiryDate":"styles_newExpiryDate__319Gp","footer":"styles_footer__2XTeO"};